import { IAppInfo } from "@logex/framework/lg-application";

export class AppInfo implements IAppInfo {
    private _prodPattern = /\w{2}-prod/i;

    environment: string;
    fullAppName: string;
    productId: string;
    toolInstanceName: string;
    versionNumber: string;
    overrideCurrencyPrefix: string;
    overrideCurrencySuffix: string;

    doNotDoGaTracking(): boolean {
        return false;
    }

    public isProduction(): boolean {
        return !!(
            this.environment &&
            (this.environment.toLowerCase() === "production" ||
                this._prodPattern.test(this.environment.toLocaleLowerCase()))
        );
    }
}
